import {DateFilterPredicate} from 'src/hooks/filtered-data/date-filter-predicate';
import {FilterPredicate} from 'src/hooks/filtered-data/filter-predicate';
import {StringFilterPredicate} from 'src/hooks/filtered-data/string-filter-predicate';
import {Filters} from 'src/modules/change-requests/typedefs';
import {ChangeRequest} from 'src/openapi/models/ChangeRequest';

export const createPredicates = (filters: Filters): FilterPredicate<ChangeRequest>[] => {
    return [
        new StringFilterPredicate((row: ChangeRequest) => row.event.type, filters.type),
        new StringFilterPredicate((row: ChangeRequest) => row.event.source, filters.source),
        new StringFilterPredicate((row: ChangeRequest) => row.event.code, filters.code),
        new StringFilterPredicate((row: ChangeRequest) => row.event.description, filters.description),
        new StringFilterPredicate((row: ChangeRequest) => row.authorEmail, filters.authorEmail),
        new StringFilterPredicate((row: ChangeRequest) => row.status, filters.status),
        new DateFilterPredicate((row: ChangeRequest) => row.updateDate, filters.updateDate),
        new DateFilterPredicate((row: ChangeRequest) => row.dueDate, filters.dueDate),
    ];
};
